import React from 'react';
import './sec1_login.css'
import Logincard from '../component/common/login_card';

const Sec1login = () => {
    return ( 
        <section className='sec1'>
            <div className='circle-dec-sec1'></div>
             <div className='circl2-sec1-dec'></div>
             <Logincard />
        </section>
     );
}
 
export default Sec1login;